import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InquiryProgressIndicator',
  props: {
    status: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const steps = ["Új", "Ajánlat elküldve", "Ajánlat elfogadva", "Lefoglalva"];

const STATUS_TO_STEP: Record<string, number> = {
  NEW: 0,
  PENDING: 0,
  "OFFER SENT": 1,
  "OFFER ACCEPTED": 2,
  BOOKED: 3,
};

const currentStep = computed(() => STATUS_TO_STEP[props.status] ?? 0);

// Step 1 (OFFER SENT) is the only step where the customer needs to act
const isCustomerAction = computed(() => currentStep.value === 1);

const dotColor = (index: number): string => {
  if (index === currentStep.value && isCustomerAction.value) return "warning";
  if (index <= currentStep.value) return "primary";
  return "grey-lighten-2";
};

const dotVariant = (index: number): "flat" | "outlined" | undefined => {
  if (index < currentStep.value) return "flat";
  if (index === currentStep.value) return "outlined";
  return "flat";
};

const __returned__ = { props, steps, STATUS_TO_STEP, currentStep, isCustomerAction, dotColor, dotVariant, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})